export const JOBS_REGIONS = [
  {
    guid: 'r:lmc:jobs:czech:republic',
    caption: 'Česká republika'
  },
  {
    guid: 'r:lmc:jobs:hlavni:mesto:praha',
    caption: 'Praha'
  },
  {
    guid: 'r:lmc:jobs:jihocesky',
    caption: 'Jihočeský'
  },
  {
    guid: 'r:lmc:jobs:jihomoravsky',
    caption: 'Jihomoravský'
  },
  {
    guid: 'r:lmc:jobs:karlovarsky',
    caption: 'Karlovarský'
  },
  {
    guid: 'r:lmc:jobs:kralovehradecky',
    caption: 'Královéhradecký'
  },
  {
    guid: 'r:lmc:jobs:liberecky',
    caption: 'Liberecký'
  },
  {
    guid: 'r:lmc:jobs:moravskoslezsky',
    caption: 'Moravskoslezský'
  },
  {
    guid: 'r:lmc:jobs:olomoucky',
    caption: 'Olomoucký'
  },
  {
    guid: 'r:lmc:jobs:pardubicky',
    caption: 'Pardubický'
  },
  {
    guid: 'r:lmc:jobs:plzensky',
    caption: 'Plzeňský'
  },
  {
    guid: 'r:lmc:jobs:stredocesky',
    caption: 'Středočeský',
    pickerCaption: 'Středočeský'
  },
  {
    guid: 'r:lmc:jobs:ustecky',
    caption: 'Ústecký'
  },
  {
    guid: 'r:lmc:jobs:vysocina',
    caption: 'Vysočina'
  },
  {
    guid: 'r:lmc:jobs:zlinsky',
    caption: 'Zlínský'
  }
]
